/**
 * Server-pushed hotel-site browser reads (BroadcastService MESSAGE_HOTEL_SITE_VIEW), sent only to employees: each
 * hotel's page after every step while its own website is read for direct rates, then its outcome.
 */
export interface HotelSiteViewEvent {
  chat_id: number
  /** a hotel id, or a string key for a tile that is not one of our hotels (an Airbnb search or listing) */
  hotel_id: number | string
  hotel_name: string
  /** the chain's site, e.g. "marriott.com" */
  site: string
  /** "reading" while the browser works, then the outcome: rates, sold_out, blocked, failed, not_found, ... */
  status: string
  step?: string
  /** the page as a base64 JPEG */
  frame?: string
  /** what the site offered, or why it couldn't be read */
  summary?: string
  /** 0 to 1 across the read's phases: finding the page, opening its rates, reading them */
  progress?: number
  /** the hotel's own photo path, on the first event, shown until the site's first page */
  photo?: string
  /** the rates page the outcome was read on */
  quote_url?: string
  at: { epoch_millis: number }
}

type Listener = (event: HotelSiteViewEvent) => void

const listeners = new Set<Listener>()

export function dispatchHotelSiteViewEvent(event: HotelSiteViewEvent) {
  listeners.forEach((listener) => listener(event))
}

/** Subscribe; returns the unsubscribe function. */
export function onHotelSiteViewEvent(listener: Listener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
